/**
 * Create block select
 * @param {object} block - Trigger block
 * @param {string} id - Id trigger
 * @param {string} not - Operator not
 * @param {string} idFunction - Id function
 * @returns {object} returned trigger
 * @example
 * createBlockSelect(block, id, not, idFunction)
 */

export const createBlockSelect = (block, id, not, idFunction) => {
    const newBlock = { id: id, not: not, blocks: [block] };

    if (idFunction) {
        newBlock.idFunction = idFunction;
    }

    return newBlock;
};
